import { Button, Popconfirm, Tooltip } from "@arco-design/web-react";

/**
 * 表格操作列统一图标按钮：无文字的圆形图标按钮，悬浮时通过 Tooltip 显示操作文字。
 * 需要二次确认的操作传入 confirmTitle/confirmContent，点击时弹出 Popconfirm，
 * 嵌套顺序为 Tooltip（悬浮提示）> Popconfirm（点击确认）> Button。
 * label 同时作为按钮的 aria-label，保证无文字图标按钮的可访问性。
 */
const OperationButton = ({
    icon,
    label,
    status,
    loading,
    disabled,
    confirmTitle,
    confirmContent,
    onConfirm,
    onClick,
}) => {
    const button = (
        <Button
            type="text"
            shape="circle"
            size="small"
            status={status}
            icon={icon}
            loading={loading}
            disabled={disabled}
            aria-label={label}
            // 确认模式下点击由 Popconfirm 接管弹出确认框，onClick 不再绑定
            onClick={confirmTitle ? undefined : onClick}
        />
    );

    // disabled 按钮不派发鼠标事件，包裹一层 span 保证 Tooltip 仍可悬浮提示
    const content = confirmTitle ? (
        <Popconfirm focusLock title={confirmTitle} content={confirmContent} onOk={onConfirm}>
            {button}
        </Popconfirm>
    ) : (
        button
    );

    return (
        <Tooltip content={label}>
            {disabled ? <span>{content}</span> : content}
        </Tooltip>
    );
};

export default OperationButton;
